import { Grid } from 'components/ui';
import type { BackupCodesContainerProps } from './BackupCodesContainer.props';

const BackupCodesContainer = ({ children }: BackupCodesContainerProps) => <Grid container>{children}</Grid>;

export default BackupCodesContainer;
